module.exports = __webpack_public_path__ + "assets/img/most_comment.eb4ca7d2.svg";